import React from "react";

var settingsSvg = function settingsSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.74 15.901l-.227-2.432a5.632 5.632 0 0 1-1.329-.55l-1.88 1.558a8.046 8.046 0 0 1-1.781-1.78l1.558-1.881a5.632 5.632 0 0 1-.55-1.329L.099 9.26a8.06 8.06 0 0 1 0-2.518l2.432-.228c.127-.47.313-.916.55-1.329l-1.558-1.88a8.046 8.046 0 0 1 1.78-1.781L5.185 3.08a5.632 5.632 0 0 1 1.329-.55L6.74.099a8.06 8.06 0 0 1 2.518 0l.228 2.432c.47.127.916.313 1.329.55l1.88-1.558a8.046 8.046 0 0 1 1.781 1.78L12.92 5.185c.237.413.423.859.55 1.329l2.432.228a8.06 8.06 0 0 1 0 2.518l-2.432.228c-.127.47-.313.916-.55 1.329l1.558 1.88a8.046 8.046 0 0 1-1.78 1.781l-1.881-1.558a5.632 5.632 0 0 1-1.329.55l-.228 2.432a8.06 8.06 0 0 1-2.518 0zM8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
    fillRule: "evenodd"
  }));
};

settingsSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var settings = {
  category: 'icon',
  colorable: true,
  name: 'settings',
  svg: settingsSvg
};